import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  ChangeDetectorRef,
} from "@angular/core";

@Component({
  selector: "app-timer",
  templateUrl: "./timer.component.html",
  styleUrls: ["./timer.component.scss"],
})
export class TimerComponent implements OnChanges, OnDestroy {
  @Input() startCounting: boolean = false;
  @Input() timerValue: number = 0;

  private intervalId: any = null;
  displayValue: number = 0;
  private lastTick: number | null = null;

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.startCounting) {
      const shouldCount = changes.startCounting.currentValue;
      
      if (shouldCount && !this.intervalId) {
        this.displayValue = this.timerValue || 0;
        this.lastTick = Date.now();
        this.startTimer();
      } else if (!shouldCount && this.intervalId) {
        this.stopTimer();
      }
    }

    if (changes.timerValue && changes.timerValue.currentValue !== undefined) {
      const newValue = changes.timerValue.currentValue || 0;
      
      if (newValue === 0) {
        this.displayValue = 0;
        if (this.intervalId) {
          this.stopTimer();
        }
        this.lastTick = null;
        this.cdr.detectChanges();
        return;
      }

      if (!this.startCounting || !this.intervalId) {
        this.displayValue = newValue;
        this.lastTick = Date.now();
        this.cdr.detectChanges();
        return;
      }

      if (this.intervalId && newValue > this.displayValue) {
        const diff = newValue - this.displayValue;
        if (diff > 5) {
          this.displayValue = newValue;
          this.lastTick = Date.now();
          this.cdr.detectChanges();
        }
      }
      // Se o valor do backend for menor ou igual, não atualizar
      // O timer continua incrementando a partir do valor atual (que é mais recente)
    }
  }

  ngOnDestroy(): void {
    this.stopTimer();
  }

  private startTimer(): void {
    if (this.intervalId) {
      return; 
    }

    this.lastTick = Date.now();
    // Incrementar a partir do valor atual do backend
    this.intervalId = setInterval(() => {
      if (this.lastTick === null) {
        this.lastTick = Date.now();
      }

      const now = Date.now();
      const diffSeconds = Math.floor((now - this.lastTick) / 1000);

      if (diffSeconds > 0) {
        this.displayValue += diffSeconds;
        this.lastTick = now;
        this.cdr.detectChanges();
      }
    }, 1000);
  }

  private stopTimer(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
    this.lastTick = null;
  }
}
